function getQuarterBounds() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth(); // 0-based
  const quarterStart = Math.floor(month / 3) * 3;
  const start = new Date(year, quarterStart, 1).getTime();
  const end = new Date(year, quarterStart + 3, 1).getTime();
  const quarterNames = ['Q1', 'Q2', 'Q3', 'Q4'];
  const qLabel = quarterNames[Math.floor(month / 3)];
  return { start, end, label: `${qLabel} ${year}` };
}

export default function Dashboard({ items }) {
  const { start, end, label } = getQuarterBounds();

  const skippedItems = items.filter(i => i.status === 'skipped');
  const quarterSkipped = skippedItems.filter(
    i => i.decidedAt >= start && i.decidedAt < end
  );

  const totalSavedQuarter = quarterSkipped.reduce(
    (sum, i) => sum + (i.price || 0),
    0
  );

  const totalSavedAllTime = skippedItems.reduce(
    (sum, i) => sum + (i.price || 0),
    0
  );

  const skippedCount = skippedItems.length;
  const boughtCount = items.filter(i => i.status === 'bought').length;

  const skipRate = skippedCount + boughtCount > 0
    ? Math.round((skippedCount / (skippedCount + boughtCount)) * 100)
    : null;

  return (
    <div className="dashboard">
      <div className="dashboard-hero">
        <p className="hero-label">Saved this quarter ({label})</p>
        <p className="hero-amount">${totalSavedQuarter.toFixed(2)}</p>
        <p className="hero-sub">
          {quarterSkipped.length} item{quarterSkipped.length !== 1 ? 's' : ''} skipped
        </p>
      </div>

      <div className="stat-grid">
        <div className="stat-card">
          <span className="stat-value">${totalSavedAllTime.toFixed(2)}</span>
          <span className="stat-label">All-time saved</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{skippedCount}</span>
          <span className="stat-label">Items skipped</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{boughtCount}</span>
          <span className="stat-label">Items bought</span>
        </div>
        {skipRate !== null && (
          <div className="stat-card stat-card--highlight">
            <span className="stat-value">{skipRate}%</span>
            <span className="stat-label">Impulse control rate</span>
          </div>
        )}
      </div>

      {skippedCount === 0 && boughtCount === 0 && (
        <div className="dashboard-empty">
          <p>Make your first decision from the Wishlist tab and your savings will appear here.</p>
        </div>
      )}
    </div>
  );
}
